import { createSelector } from '@reduxjs/toolkit';
import pickBy from 'lodash/pickBy';

import isValidSbatGroupFilter from '@classCreation/utils/isValidSbatGroupFilter';

const baseSelector = (state) => state.rescheduleClassesFilter;

export const rescheduleClassesFilterSelector = baseSelector;

export const isRescheduleClassesFilterModalOpenSelector = createSelector(
  (state) => baseSelector(state).isModalOpen,
  (isModalOpen) => isModalOpen
);

export const rescheduleClassesAppliedFiltersSelector = createSelector(
  (state) => baseSelector(state).primaryInstructors.applied,
  (state) => baseSelector(state).secondaryInstructors.applied,
  (state) => baseSelector(state).academyModules.applied,
  (state) => baseSelector(state).classType.applied,
  (state) => baseSelector(state).lectureType.applied,
  (state) => baseSelector(state).fromDate.applied,
  (state) => baseSelector(state).toDate.applied,
  (
    primaryInstructors,
    secondaryInstructors,
    academyModules,
    classType,
    lectureType,
    fromDate,
    toDate
  ) => ({
    primaryInstructors,
    secondaryInstructors,
    academyModules,
    classType,
    lectureType,
    fromDate,
    toDate,
  })
);

export const rescheduleClassesCurrentFiltersSelector = createSelector(
  (state) => baseSelector(state).primaryInstructors.current,
  (state) => baseSelector(state).secondaryInstructors.current,
  (state) => baseSelector(state).academyModules.current,
  (state) => baseSelector(state).classType.current,
  (state) => baseSelector(state).lectureType.current,
  (state) => baseSelector(state).fromDate.current,
  (state) => baseSelector(state).toDate.current,
  (
    primaryInstructors,
    secondaryInstructors,
    academyModules,
    classType,
    lectureType,
    fromDate,
    toDate
  ) => ({
    primaryInstructors,
    secondaryInstructors,
    academyModules,
    classType,
    lectureType,
    fromDate,
    toDate,
  })
);

export const areRescheduleClassesAppliedFiltersPresentSelector = createSelector(
  rescheduleClassesAppliedFiltersSelector,
  (appliedFilters) => {
    const filters = pickBy(appliedFilters, isValidSbatGroupFilter);
    return Object.keys(filters).length > 0;
  }
);

export const areRescheduleClassesCurrentFiltersPresentSelector = createSelector(
  rescheduleClassesCurrentFiltersSelector,
  (currentFilters) => {
    const filters = pickBy(currentFilters, isValidSbatGroupFilter);
    return Object.keys(filters).length > 0;
  }
);
